import { faClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSearchParams } from "next/navigation";
import * as React from "react";
interface SearchDropdownProps {
    setIsSearchOpen: Function;
}
export default function SearchDropdown({
    setIsSearchOpen,
}: SearchDropdownProps) {
    const params = useSearchParams();
    const searchValue = params?.get("q")?.replaceAll("+", " ");


    return (
        <form
            className="lg:flex lg:space-x-2 lg:items-center lg:h-10"
            method="GET"
            action={"/search"}
        >
            <div className="relative lg:w-full lg:h-full">
                <input
                    type="text"
                    name="q"
                    placeholder="Search"
                    defaultValue={searchValue}
                    className="w-80 p-2 bg-gray-100 rounded flex items-center justify-center font-[400] text-[13px] transition-all duration-500 dark:bg-ngdarkdray dark:text-white focus:outline-none placeholder:text-gray-300 lg:w-full lg:h-full"
                />
                <FontAwesomeIcon
                    icon={faClose}
                    className="cursor-pointer absolute right-0 pr-3 top-1/2 -translate-y-1/2 hover:text-primary transition-all"
                    onClick={() => setIsSearchOpen(false)}
                />
            </div>
            <button
                type="submit"
                className="h-full text-[13px] px-4 rounded bg-gray-100 dark:bg-primary cursor-pointer hover:bg-primary hover:text-white hidden lg:block"
            >
                <FontAwesomeIcon icon={faSearch} className="" />
            </button>
        </form>
    );
}
